import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLocale } from '../contexts/LocaleContext';

const TermsOfService: React.FC = () => {
  const { t } = useLocale();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-4 py-20">
        <h1 className="text-2xl font-semibold mb-4">{t.pages?.termsOfService?.title || 'Terms of Service'}</h1>
        <div className="prose">
          <p>{t.pages?.termsOfService?.content || 'Placeholder terms of service content. Replace with the real text.'}</p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
